export const coursesLessonsPerPageOptions = [
  { label: '100', value: 100 },
  { label: '200', value: 200 },
  { label: '500', value: 500 },
];

export const DEFAULT_COURSES_LESSONS_PER_PAGE = 100;
